const getCurrencyCode = () => {
	const currencyISO = window?.dataLayer?.[0]?.navigation?.currencyISO;

	return currencyISO ?? '';
};

export default getCurrencyCode;
